/**
 * Stable CSS class names for E2E — ShippingCompanyRequest page and modal.
 * Containers use `shipping-company-request__<element>`; inputs and
 * user-interactable controls use `shipping-company-request-input--<name>`.
 */
export const SCR = {
    page: 'shipping-company-request-page',
    root: 'shipping-company-request',

    loading: 'shipping-company-request__loading',
    breadcrumb: 'shipping-company-request__breadcrumb',

    filters: 'shipping-company-request__filters',
    searchBox: 'shipping-company-request__search-box',
    inputSearchBoxPaper: 'shipping-company-request-input--search-box-paper',
    inputCargoCompany: 'shipping-company-request-input--cargo-company',
    inputShippingNo: 'shipping-company-request-input--shipping-no',
    btnSend: 'shipping-company-request-input--button-send',

    btnBatchSearch: 'shipping-company-request-input--button-batch-search',

    grid: 'shipping-company-request__grid',
    cellId: 'shipping-company-request__cell-id',
    cellShippingNo: 'shipping-company-request__cell-shipping-no',
    cellMessage: 'shipping-company-request__cell-message',
    cellMessageText: 'shipping-company-request__cell-message-text',
    cellStatus: 'shipping-company-request__cell-status',
    cellStatusIcon: 'shipping-company-request__cell-status-icon',
    cellStatusIconSuccess: 'shipping-company-request__cell-status-icon--success',
    cellStatusIconError: 'shipping-company-request__cell-status-icon--error',

    emptyState: 'shipping-company-request__empty-state',

    /* --- Batch search modal -------------------------------------------- */
    batchModal: 'shipping-company-request__batch-modal',
    batchModalPaper: 'shipping-company-request__batch-modal-paper',
    batchModalTitle: 'shipping-company-request__batch-modal-title',
    batchModalClose: 'shipping-company-request-input--button-batch-modal-close',
    batchModalBody: 'shipping-company-request__batch-modal-body',
    inputBatchOrderNo: 'shipping-company-request-input--batch-order-no',
} as const;

export const scrCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
